import React from "react";
import { X } from "lucide-react";

type SnackBarProps = {
  open: boolean;
  message: string;
  onClose: () => void;
  variant?: "info" | "success" | "warning" | "error";
};

export default function AlertBox({
  open,
  message,
  onClose,
  variant = "info",
}: SnackBarProps) {
  if (!open) return null;

  const bgColors: Record<string, string> = {
    info: "#017cc9",     // blue-600
    success: "#16a34a",  // green-600
    warning: "#ca8a04",  // yellow-600
    error: "#dc2626",    // red-600
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "10px",
        left: "55%",
        transform: "translateX(-50%)",
        zIndex: 999999, // higher than dialogs, drawers, modals
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          backgroundColor: bgColors[variant],
          color: "white",
          padding: "12px 20px",
          borderRadius: "9999px",
          minWidth: "350px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          {message}
        </span>

        <button
          onClick={onClose}
          style={{
            backgroundColor: "rgba(255,255,255,0.2)",
            padding: "4px",
            borderRadius: "50%",
            border: "none",
            cursor: "pointer",
            transition: "0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)")
          }
        >
          <X size={16} color="white" />
        </button>
      </div>
    </div>
  );
}
